import store from '@/store';
import Vue from 'vue';
import ssAxios from "@/services/SelfServes/SSAxios";

export default function (to, from, next) {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!localStorage.getItem('user')) {
            store.commit('setLink', to);
            next('/login?loginError=true');
        } else {
            const user = JSON.parse(localStorage.getItem('user'));

            if (to.matched.some(record => record.meta.isAdmin)) {
                if (user.group_id === Vue.prototype.$userType.Admin) {
                    next();
                } else {
                    next('/');
                }
            } else {
                next();
            }
        }
    } else if (to.matched.some(record => record.meta.requiresNotAuth) && localStorage.getItem('user')) {
        next('/');
    } else if (to.matched.some(record => record.meta.ssRequiresAuth)) {
        if (!localStorage.getItem('ss_access_token')) {
            handleSSUserDeletion();
            const route = localStorage.getItem('ss_department_hash')
                ? `/self-serves/${localStorage.getItem('ss_department_hash')}`
                : '/self-serves';

            if (!from.name) {
                next(false);
                next(route);
            } else {
                setTimeout(() => {
                    next(route);
                }, 100);
            }
        } else if (!store.getters.ssShipperId) {
            getSSUserFromRequest(next);
        } else {
            next();
        }
    } else {
        next();
    }
}

function getSSUserFromRequest(next) {
    ssAxios.httpClient.post(Vue.prototype.$apiRouter.ssGetShipper, {
        hash: localStorage.getItem('ss_department_hash')
    })
        .then(response => {
            if (response.status === 200) {
                const {User, Address} = response.data.data;
                store.commit('ssClearShipper');
                store.commit('ssSetShipper', User);
                store.commit('ssSetShipperAddressBook', Address);
                next();
            }
        })
        .catch(error => {
            handleSSUserDeletion();
            // eslint-disable-next-line no-console
            console.error(error);
            next();
        });
}

function handleSSUserDeletion() {
    store.commit('ssClearProducts');
    store.commit('ssClearOrders');
    store.commit('ssClearShipper');
    localStorage.removeItem('ss_access_token');
    localStorage.removeItem('ss_refresh_token');
}
